module.exports = __webpack_public_path__ + "img/CPH_mobile_master-compressor.7d153f72.png";